export default __webpack_public_path__ + "static/New-York-de7a0230e21742bd74ee081f8d90b4a3.webp";